import React, { useState, useCallback } from "react";
import {
  useCreateMeetingMutation,
  useUpdateMeetingMutation,
} from "../api/MeetingsApi";
import { FinancialData } from "@mekimix/shared/src/types/FinancialData";

interface NextMeetingFormProps {
  currentMeeting: {
    id: string;
    family_id: string;
    mentor_id: string;
    location: string;
    attendees: string[];
    meeting_number: number;
    financialData?: FinancialData;
    financial_data_id?: string;
  };
}

const NextMeetingForm: React.FC<NextMeetingFormProps> = ({ currentMeeting }) => {
  console.log("current meeting ::::   ", currentMeeting);

  const [createMeeting] = useCreateMeetingMutation();
  const [updateMeeting] = useUpdateMeetingMutation();
  const [showForm, setShowForm] = useState(false);
  const [date, setDate] = useState("");
  const [location, setLocation] = useState("");
  const [attendees, setAttendees] = useState<string[]>([]);
  const [successMessage, setSuccessMessage] = useState(false);

  const convertFinancialDataToSnakeCase = (data: any) => ({
    id: undefined as any,
    total_income: data.totalIncome,
    total_expenses: data.totalExpenses,
    current_debt_amount: data.currentDebtAmount,
    one_time_debt_repayment: data.oneTimeDebtRepayment,
    monthly_debt_repayment: data.monthlyDebtRepayment,
    short_term_savings: data.shortTermSavings,
    long_term_savings: data.longTermSavings,
    income_expense_difference: data.incomeExpenseDifference,
    difference_after_repayment: data.differenceAfterRepayment,
  });
  console.log("convertFinancialDataToSnakeCase:", convertFinancialDataToSnakeCase);

  const handleSubmit = useCallback(
    async (e: React.FormEvent) => {
      e.preventDefault();
      console.log("handleSubmit נקרא");
      console.log("currentMeeting:", currentMeeting);
      console.log("date:", date);
      if (!currentMeeting || !date) {
        console.log("אין currentMeeting או תאריך");
        return;
      }

      try {
        const { id, financialData, financial_data_id, ...rest } = currentMeeting;
        const meetingData = {
          ...rest,
          date,
          location: location || currentMeeting.location,
          attendees: attendees.length ? attendees : currentMeeting.attendees || [],
          meeting_number: currentMeeting.meeting_number + 1,
        };

        const cleanFinancialData = currentMeeting.financialData
          ? convertFinancialDataToSnakeCase(currentMeeting.financialData)
          : undefined;

        console.log(" לפני השליחה ל-DB : ", cleanFinancialData);
        const createMeetingToSend = {
          meetingData,
          financialData: cleanFinancialData
        };
        console.log("createMeetingToSend:", createMeetingToSend);
        await createMeeting(createMeetingToSend).unwrap();

        await updateMeeting({
          id: currentMeeting.id,
          updatedData: {
            next_meeting_date: date,
          },
        });
        setSuccessMessage(true);
        setDate("");
        setLocation("");
        setAttendees([]);
        setShowForm(false);
      } catch (err: any) {
        console.log("❌ שגיאה בשמירת הפגישה הבאה:", err);
        console.error("❌ שגיאה בשמירת הפגישה הבאה:", err);
        alert("אירעה שגיאה בשמירת הפגישה. בדקי את הנתונים שנשלחים.");
      }
    },
    [createMeeting, updateMeeting, currentMeeting, date, location, attendees]
  );

  return (
    <div className="p-4 border rounded bg-gray-50 mt-4">
      {successMessage && (
        <div className="text-green-700 bg-green-100 border border-green-400 rounded px-4 py-2 mb-4">
          הפגישה הבאה נשמרה בהצלחה
        </div>
      )}
      {!showForm ? (
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={() => setShowForm(true)}
        >
          הוסף פגישה הבאה
        </button>
      ) : (
        <form onSubmit={handleSubmit}>
          <h3 className="text-lg font-semibold mb-2">פרטי הפגישה הבאה</h3>

          <label className="block mb-1">תאריך הפגישה:</label>
          <input
            type="date"
            className="border p-2 rounded w-full mb-3"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
          <label className="block mb-1">מיקום:</label>
          <input
            type="text"
            className="border p-2 rounded w-full mb-3"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
          <label className="block mb-1">משתתפים:</label>
          <input
            type="text"
            placeholder="הפרדי פסיקים בין משתתפים"
            className="border p-2 rounded w-full mb-3"
            onChange={(e) =>
              setAttendees(
                e.target.value
                  .split(",")
                  .map((s) => s.trim())
                  .filter(Boolean)
              )
            }
          />
          <div className="flex gap-2">
            <button
              type="submit"
              className="bg-green-600 text-white px-4 py-2 rounded"
            >
              שמור פגישה הבאה
            </button>
            <button
              type="button"
              className="bg-gray-400 text-white px-4 py-2 rounded"
              onClick={() => setShowForm(false)}
            >
              בטל
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default NextMeetingForm;